import { createContext, useContext } from 'react'
import type { ComponentType } from '@/types/schemas/workspace'

export interface WorkspaceMosaicContextValue {
  /** `initialState` seeds the new panel's state (e.g. a scanner's request for Scanner Parity). */
  addPanel: (componentType?: ComponentType, initialState?: Record<string, unknown>) => void
  isPlacementMode: boolean
  cancelPlacement: () => void
  /** The visual Add Panel rail (Panel Hub) is showing. */
  isPanelHubOpen: boolean
  /** No-op when the layout is locked (Home) or has no desktop mosaic. */
  togglePanelHub: () => void
  closePanelHub: () => void
}

export const WorkspaceMosaicContext = createContext<WorkspaceMosaicContextValue | null>(null)

export function useWorkspaceMosaic(): WorkspaceMosaicContextValue {
  const ctx = useContext(WorkspaceMosaicContext)
  if (!ctx) throw new Error('useWorkspaceMosaic must be used within WorkspaceMosaic')
  return ctx
}
